import { Skeleton } from '@/components/ui/skeleton';

export function TileSkeletonLoader() {
  return (
    <div className="space-y-3 p-4">
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-10 w-16" />
      <Skeleton className="h-3 w-32" />
      <Skeleton className="h-3 w-20" />
    </div>
  );
}
